const feedbackList = () => import("@/pages/feedback/index.vue");
const feedbackDetail = () => import("@/pages/feedback/detail.vue");

export default [
    {
        path: "/feedback/list",
        component: feedbackList,
        meta: [
            {
                name: "用户反馈",
            },
            {
                name: "用户反馈列表",
                activeRoute: "/feedback/list",
            },
        ],
    },
    {
        path: "/feedback/detail",
        component: feedbackDetail,
        meta: [
            {
                name: "用户反馈",
            },
            {
                name: "用户反馈列表",
                url: "/feedback/list",
            },
            {
                name: "用户反馈详情",
                activeRoute: "/feedback/list",
            },
        ],
    },
];
